module.exports = __webpack_public_path__ + "img/Avatar-12.665d05de.gif";